import {AuthModel} from './_models'
import {isOnPremisesInstallation} from './onPremisesAccess'
import {staffCan} from './staffAccess'

type ShahrReportUser = Partial<Pick<AuthModel, 'rl' | 'staff' | 'isOnPremises'>>

/**
 * «گزارش بانک شهر» is for staff granted «گزارش‌ها» only, from whatever business is selected (the user,
 * 1405/07/18). Shahr Bank is no business of the panel, and support sessions are never staff.
 * Shahr Bank is ASA's own customer, so the bank's on-premises install has no such report (the user,
 * 1405/07/25: «صفحه گزارش ایسان و بانک شهر توی نسخه فاش نباید باشه»).
 */
export const canViewShahrReport = (user?: ShahrReportUser | null): boolean =>
  staffCan(user, 'reports') && !isOnPremisesInstallation(user)
